import { useState, FC, MouseEvent } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { noop } from 'lodash-es'
import ConfirmDialog from '@components/ConfirmDialog'
import getCSRFToken from '@utils/csrf'
import { LinkActionProps } from '../../types'

const LinkAction: FC<LinkActionProps> = props => {
  const { href, text, method = null, confirm = null, onDone = noop } = props

  const [showConfirm, setShowConfirm] = useState(false)

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (confirm) {
      setShowConfirm(true)
      e.preventDefault()
      // Note: Our onclick prop is called when the user makes thir confirm dialog choice
      return
    }

    const normalizedMethod = method ? method.toUpperCase() : 'GET'
    if (['PUT', 'PATCH', 'DELETE'].includes(normalizedMethod)) {
      e.preventDefault()
      submitForm(normalizedMethod)
    }
    onDone()
  }

  const submitForm = (normalizedMethod: string) => {
    const csrfToken = getCSRFToken()
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = href
    form.innerHTML = `
      <input type="hidden" name="_method" value="${normalizedMethod}">
      <input type="hidden" name="authenticity_token" value="${csrfToken}">
    `
    document.body.appendChild(form)
    form.submit()
  }

  const handleConfirm = () => {
    setShowConfirm(false)
    submitForm(method ? method.toUpperCase() : 'GET')
    handleConfirmOrCancel()
  }

  const handleCancel = () => {
    setShowConfirm(false)
    handleConfirmOrCancel()
  }

  // this is called after the user has made their choice in the confirm dialog
  const handleConfirmOrCancel = () => {
    onDone()
  }

  const getConfirmDialogContent = () => {
    if (showConfirm) {
      return (
        <CSSTransition classNames="modal-in-out" timeout={200}>
          <ConfirmDialog
            title={confirm?.title || ''}
            message={confirm?.message || ''}
            isOpen={showConfirm}
            setIsOpen={setShowConfirm}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
          />
        </CSSTransition>
      )
    }
    return null
  }

  return (
    <>
      <a href={href} onClick={handleClick}>
        {text}
      </a>
      <TransitionGroup>{getConfirmDialogContent()}</TransitionGroup>
    </>
  )
}

export default LinkAction
